import { Component } from '@angular/core';
import { AnimateDirective } from '../directives/animate.directive';

@Component({
  selector: 'app-testimonials-v2',
  standalone: true,
  imports: [AnimateDirective],
  template: `
    <section class="py-16 md:py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div class="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-[#FF5500]/5 via-transparent to-transparent pointer-events-none"></div>

      <div class="container mx-auto px-4 md:px-6 relative z-10">
        <div class="max-w-4xl mx-auto text-center mb-12">
          <h2 appAnimate class="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
            Quem já protegeu sua operação fala por nós.
          </h2>
        </div>

        <div class="grid md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">

          @for (t of testimonials; track t.author; let i = $index) {
            <div appAnimate [delay]="150 + (i * 150)" class="h-full">
              <div class="bg-[#1c1c1c] border border-white/5 rounded-2xl p-8 flex flex-col h-full hover:border-[#FF5500]/30 transition-all duration-300">
                <div class="flex gap-1 mb-5">
                  @for (star of [1,2,3,4,5]; track star) {
                    <span class="text-[#FF5500] text-lg">★</span>
                  }
                </div>
                <p class="text-gray-200 text-base leading-relaxed flex-1 mb-6 italic">
                  "{{ t.quote }}"
                </p>
                <p class="text-sm font-semibold text-[#FF5500]">— {{ t.author }}</p>
              </div>
            </div>
          }

        </div>

        <p appAnimate [delay]="600" class="text-center text-gray-400 text-sm mt-10">
          <span class="text-[#FF5500]">★★★★★</span> Avaliação média de 4.9/5 entre nossos clientes ativos
        </p>
      </div>
    </section>
  `
})
export class TestimonialsV2Component {
  testimonials = [
    {
      quote: 'Antes da beetrack, eu torcia para que o fiscal não aparecesse. Hoje, eu tenho o relatório pronto antes de ele pedir.',
      author: 'Gerente de RH, Frigorífico de Aves, SP'
    },
    {
      quote: 'Já tinha sofrido 2 ações trabalhistas por pausa térmica. Com a beetrack, zerou. Paguei o sistema em menos de 1 mês de economia.',
      author: 'Proprietário, Frigorífico, RS'
    },
    {
      quote: 'A instalação foi mais rápida do que esperávamos. Em 30 dias já estávamos monitorando 3 câmaras frias e 180 colaboradores.',
      author: 'Gerente de Operações, Distribuidora de Alimentos, MG'
    }
  ];
}
